const REFUND_POLICY_KEYS = {
  0: 'custom',
  1: 'no_refund',
  2: 'full',
  3: 'day7',
  4: 'day30',
  5: 'day45',
  6: 'day60',
  7: 'day90'
};

const normalizeRefundPolicy = refundPolicy =>
  Object.prototype.hasOwnProperty.call(REFUND_POLICY_KEYS, refundPolicy)
    ? REFUND_POLICY_KEYS[refundPolicy]
    : refundPolicy;

const normalizeWlsRefundPolicy = listing => {
  if (!listing) return listing;

  return {
    ...listing,
    refund_policy: normalizeRefundPolicy(listing.refund_policy)
  };
};

module.exports = normalizeWlsRefundPolicy;
module.exports.normalizeRefundPolicy = normalizeRefundPolicy;
